import type { ContentfulImageParams } from "@2u-landing-pages/types";

type Viewport = "desktop" | "mobile";
type Direction = "top" | "bottom" | "left" | "right";
type Axis = "height" | "width";

type GradientOverlayVar =
  | `--overlay-${Viewport}-gradient`
  | `--overlay-${Viewport}-direction`
  | `--overlay-${Viewport}-gradient-${Axis}`
  | `--overlay-${Viewport}-${Direction}`
  | `--overlay-${Viewport}-blend-mode`
  | `--overlay-${Viewport}-solid-color`;

type GradientOverlayStyleVars = {
  [key in GradientOverlayVar]?: string;
};

export function getGradientOverlayStyle(
  config: ContentfulImageParams,
  viewport: "desktop" | "mobile"
): GradientOverlayStyleVars {
  const style: GradientOverlayStyleVars = {};

  const {
    gradientType = "none",
    gradientDirection = "to top",
    gradientSize = 40,
    gradientOverlay,
    baseColor,
    blendMode,
  } = config;

  if (gradientType === "none") return style;

  const directionMap = {
    "to top":    { axis: "height", anchor: "bottom", opposite: "top" },
    "to bottom": { axis: "height", anchor: "top",    opposite: "bottom" },
    "to left":   { axis: "width",  anchor: "right",  opposite: "left" },
    "to right":  { axis: "width",  anchor: "left",   opposite: "right" },
  };

  const mapping = directionMap[gradientDirection!];

  const overlayVars: GradientOverlayStyleVars = {
    [`--overlay-${viewport}-blend-mode`]: blendMode,
  };

  if (gradientType === "gradient") {
    Object.assign(overlayVars, {
      [`--overlay-${viewport}-gradient`]: gradientOverlay!,
      [`--overlay-${viewport}-direction`]: gradientDirection!,
      [`--overlay-${viewport}-gradient-${mapping.axis}`]: `${gradientSize}%`,
      [`--overlay-${viewport}-${mapping.anchor}`]: "0",
      [`--overlay-${viewport}-${mapping.opposite}`]: "auto",
    });
  }

  if (gradientType === "solid") {
    overlayVars[`--overlay-${viewport}-solid-color`] = baseColor;
  }

  return {
    ...style,
    ...overlayVars,
  };
}
